import styled from 'styled-components';

import { CategoryRect as UICategoryRect } from '@catalyze/ui';
import type { LeadGroups } from 'constants/leadGroups';
import { leadGroupColor } from 'utils/leadGroupColor';

interface ICategoryRectProps {
    type: LeadGroups;
}

// Move width and height to UI when refactoring FA
export const CategoryRect = styled(UICategoryRect)<ICategoryRectProps>`
    width: 1.125rem;
    height: 1.125rem;
    background: ${leadGroupColor};
`;
